import React, { useEffect, useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

// TODO: Rewrite this with validator and section template
const ChangeSecretQuestion = () => {
  const [answerIsValid, setAnswerIsValid] = useState(true);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [selectedQuestion, setSelectedQuestion] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const secretAnswer = await window.CoreApi.Account.GetCurrentSecretAnswer();
      const secretQuestion = await window.CoreApi.Account.GetCurrentSecretQuestion();
      setSelectedAnswer(secretAnswer.data.data || "");
      setSelectedQuestion(secretQuestion.data.data || 0);
    }
    fetchData();
  }, []);

  const questions = [
    { key: 5, label: RESX.SecretQuestion.WhatIsTheBrandOfYourFirstCar },
    { key: 1, label: RESX.SecretQuestion.WhatIsTheNameOfYourFavoritePet },
    { key: 2, label: RESX.SecretQuestion.WhatIsTheNameOfYourHighschool },
    { key: 4, label: RESX.SecretQuestion.WhatIsYourPlaceOfBirth },
    { key: 3, label: RESX.SecretQuestion.WhatIsYourMothersMaidenName },
  ];

  const validateAnswerFormat = () => {
    if (selectedAnswer.trim() === "") {
      setAnswerIsValid(false);
    } else {
      setAnswerIsValid(true);
    }
  }

  const changeSecretQuestion = async () => {
    if (!answerIsValid) {
      return;
    }

    const r = await window.CoreApi.Account.ChangeSecretQuestion({
      secretAnswer: selectedAnswer,
      secretQuestionId: selectedQuestion
    });

    if (r.data) {
      window.location.href = routes.personal_SettingMenu().absolute;
    }
  }

  return <>
    <table className="s1_table clean rowspace">
      <tbody>
        <tr>
          <td>{RESX.PersonalSettings.SecretQuestion}</td>
          <td>
            <div>
              <BaseReactSelectDropdown
                excludeKeys={[]}
                options={questions}
                getLabel={q => q.label}
                getValue={q => q.key}
                value={questions.find(q => q.key === selectedQuestion)}
                onChange={q => setSelectedQuestion(q.key)}
                config={{}}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td>{RESX.PersonalSettings.SecretAnswer}</td>
          <td>
            <div>
              <OptionalTextInput
                value={selectedAnswer || ""}
                onChange={setSelectedAnswer}
                onBlur={validateAnswerFormat}
                hasError={!answerIsValid}
                maxLength={serverReference.constants.user.maxSecretAnswerLength} />
              <div className="grow1" style={{ color: "red" }}>
                {answerIsValid ? <div></div> : <div>{RESX.PersonalSettings.SecretAnswerCannotBeEmpty}</div>}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <div className="flex justify-end margin-top-bigger">
        <button className="button-new primary" type="button" id="btnSave" onClick={changeSecretQuestion}>{RESX.Buttons.btnSave}</button>
      </div>
    </div>
  </>
}

export default ChangeSecretQuestion;